<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Benutzer- und Gruppenverwaltung' | mrTranslate }}</span>
    </div>

    <div class="header-actions">
      <a class="nav-link nav-icon" href="javascript:void(0);" (click)="exportExcel()">
        <cds-icon shape="excel" [title]="'Benutzerverwaltung nach Excel exportieren' | mrTranslate" />
      </a>
      <a href="javascript:void(0);" class="nav-link nav-icon">
        <cds-icon shape="times" (click)="close()"></cds-icon>
      </a>
    </div>
  </header>
  <div id="benutzerverwaltungsWrapper">
    <clr-tabs>
      <!-- Rollen- und Benutzer -->
      <clr-tab>
        <button clrTabLink (click)="tabChange('roles')">
          {{ 'Rollen & Benutzer' | mrTranslate }}
        </button>
        @if (activeTabs.roles) {
          <clr-tab-content>
            <div class="clr-row nxm padding-10-t h-100">
              <div class="clr-col-3">
                <div class="clr-row" style="padding-top: 0px; margin-top: -12px">
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      align-items: center;
                      width: 100%;
                    ">
                    <h3 style="margin-left: 15px">{{ 'Rollen' | mrTranslate }}</h3>
                    <button
                      class="btn btn-outline btn-sm"
                      style="min-width: 42px; margin-top: 18px"
                      (click)="addRolle()">
                      <clr-tooltip>
                        <cds-icon clrTooltipTrigger shape="plus" size="20" class="cursor-pointer" />
                        <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                          {{ 'neue Rolle anlegen' | mrTranslate }}
                        </clr-tooltip-content>
                      </clr-tooltip>
                    </button>
                  </div>
                </div>
                <div class="limit-height">
                  @if (roles.columns.length) {
                    <clr-datagrid
                      style="padding-top: 0px"
                      class="datagrid-compact"
                      [clrDgRowSelection]="true"
                      [clrDgSelectionType]="'single'"
                      [clrDgSelected]="[selectedRole]"
                      (clrDgSelectedChange)="selectedRole = $event[0]; selectionRoleChanged($event[0])"
                      [clrDgItemsIdentityFn]="row => row?.ID">
                      @for (column of roles.columns; track column.id) {
                        <clr-dg-column [clrDgField]="column.id">
                          <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                            {{ column.id | titlecase | mrTranslate }}
                          </ng-container>
                        </clr-dg-column>
                      }
                      <ng-template
                        clrVirtualScroll
                        let-row
                        [clrVirtualRowsOf]="roles.rows"
                        [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
                        <clr-dg-row [clrDgItem]="row">
                          <clr-dg-action-overflow>
                            <button class="action-item" (click)="editRolle(row)">
                              {{ 'Bearbeiten' | mrTranslate }}
                            </button>
                            <button
                              class="action-item"
                              (click)="deleteRolle(row.ID)"
                              [disabled]="selectedUserRole.length !== 0">
                              {{ 'Löschen' | mrTranslate }}
                            </button>
                          </clr-dg-action-overflow>
                          @for (cell of roles.columns; track cell.id) {
                            <clr-dg-cell>{{ row[cell.id] }}</clr-dg-cell>
                          }
                        </clr-dg-row>
                      </ng-template>
                      <clr-dg-footer>{{ roles.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                    </clr-datagrid>
                  }
                </div>
              </div>
              @if (selectedRole) {
                <div class="clr-col-3 h-100">
                  <div class="clr-row" style="padding-top: 0px; margin-top: -12px">
                    <div
                      style="
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                      ">
                      <h3 style="margin-left: 15px">{{ 'Rechte' | mrTranslate }}</h3>
                      <button
                        class="btn btn-outline btn-sm"
                        style="min-width: 42px; margin-top: 18px"
                        (click)="sendRechte()">
                        <clr-tooltip>
                          <cds-icon clrTooltipTrigger shape="check" size="20" class="cursor-pointer" />
                          <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                            {{ 'Rechte speichern' | mrTranslate }}
                          </clr-tooltip-content>
                        </clr-tooltip>
                      </button>
                    </div>
                  </div>
                  <clr-accordion class="h-60 scroll-y" style="padding-top: 0px; margin-top: 12px">
                    <clr-accordion-panel>
                      <clr-accordion-title>
                        <clr-checkbox-wrapper style="margin-left: 5px">
                          <label>{{ 'Ansicht' | mrTranslate }}</label>
                          <input
                            type="checkbox"
                            clrCheckbox
                            [indeterminate]="chkView == 1"
                            [checked]="chkView == 2"
                            (change)="changeHeaderField($event, 'view', -1)" />
                        </clr-checkbox-wrapper>
                      </clr-accordion-title>
                      <clr-accordion-content *clrIfExpanded>
                        @for (right of selectedUserRights.view; track right) {
                          <clr-checkbox-container class="clr-form-control">
                            <clr-checkbox-wrapper>
                              <label>{{ right.descriptor | mrTranslate }}</label>
                              <input
                                [disabled]="!selectedRole"
                                type="checkbox"
                                clrCheckbox
                                [(ngModel)]="right.value"
                                (change)="changeHeaderFieldState('view', -1)" />
                            </clr-checkbox-wrapper>
                          </clr-checkbox-container>
                        }
                      </clr-accordion-content>
                    </clr-accordion-panel>
                    <clr-accordion-panel>
                      <clr-accordion-title>
                        <clr-checkbox-wrapper style="margin-left: 5px">
                          <label>{{ 'Programm' | mrTranslate }}</label>
                          <input
                            type="checkbox"
                            clrCheckbox
                            [indeterminate]="chkPro == 1"
                            [checked]="chkPro == 2"
                            (change)="changeHeaderField($event, 'pro', -1)"
                            [disabled]="selectedRoleRechte < 3" />
                        </clr-checkbox-wrapper>
                      </clr-accordion-title>
                      <clr-accordion-content *clrIfExpanded>
                        @for (right of selectedUserRights.program; track right) {
                          <clr-checkbox-container class="clr-form-control">
                            <clr-checkbox-wrapper>
                              <label>{{ right.descriptor | mrTranslate }}</label>
                              <input
                                [disabled]="selectedRoleRechte < 3"
                                type="checkbox"
                                clrCheckbox
                                [(ngModel)]="right.value"
                                (change)="changeHeaderFieldState('pro', -1)" />
                            </clr-checkbox-wrapper>
                          </clr-checkbox-container>
                        }
                      </clr-accordion-content>
                    </clr-accordion-panel>
                    @if (selectedUserRights?.type) {
                      @for (type of selectedUserRights.type | keyvalue; track type) {
                        <clr-accordion-panel>
                          <clr-accordion-title>
                            <clr-checkbox-wrapper style="margin-left: 5px">
                              <label>{{ sotyp[type.key]?.bezeichnung ?? 'Objekttyp' + type.key }}</label>
                              <input
                                type="checkbox"
                                clrCheckbox
                                [indeterminate]="chkType[type.key] == 1"
                                [checked]="chkType[type.key] == 2"
                                (change)="changeHeaderField($event, 'typ', type.key)"
                                [disabled]="selectedRoleRechte < 3" />
                            </clr-checkbox-wrapper>
                          </clr-accordion-title>
                          <clr-accordion-content *clrIfExpanded>
                            @for (right of type.value; track right) {
                              <clr-checkbox-container class="clr-form-control">
                                <clr-checkbox-wrapper>
                                  <label>{{ right.descriptor | mrTranslate }}</label>
                                  <input
                                    [disabled]="selectedRoleRechte < 3"
                                    type="checkbox"
                                    clrCheckbox
                                    [(ngModel)]="right.value"
                                    (change)="changeHeaderFieldState('typ', type.key)" />
                                </clr-checkbox-wrapper>
                              </clr-checkbox-container>
                            }
                          </clr-accordion-content>
                        </clr-accordion-panel>
                      }
                    }
                  </clr-accordion>
                </div>
              }
              <div [ngClass]="{ 'clr-col-9 nxp': !selectedRole, 'clr-col-6': selectedRole !== undefined }">
                <div class="clr-row" style="padding-top: 0px; margin-top: -12px">
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      align-items: center;
                      width: 100%;
                    ">
                    <h3 style="margin-left: 15px">{{ 'Benutzer' | mrTranslate }}</h3>
                    <button
                      class="btn btn-outline btn-sm"
                      style="min-width: 42px; margin-top: 18px"
                      (click)="addUser()"
                      [disabled]="!curSelectedRole">
                      <clr-tooltip>
                        <cds-icon clrTooltipTrigger shape="plus" size="20" class="cursor-pointer" />
                        <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                          {{ 'Neuen Benutzer anlegen' | mrTranslate }}
                        </clr-tooltip-content>
                      </clr-tooltip>
                    </button>
                  </div>
                </div>
                <!-- @if(users) {
                            <appfx-datagrid
                              [columns]="colDefs"
                              [singleRowActions]="actionDefs"
                              [selectedItems]="selectedUserRole"
                              [selectionType]="2"
                              [virtualScrolling]="true"
                              (actionClick)="setAction($event)"
                              [gridItems]="users.rows"/>
                              } -->
                @if (users?.columns.length) {
                  <clr-datagrid
                    style="padding-top: 0px; height: 30%"
                    class="datagrid-compact"
                    [clrDgSelectionType]="'multi'"
                    [(clrDgSelected)]="selectedUserRole"
                    [clrDgItemsIdentityFn]="row => row?.id">
                    @for (column of users.columns; track column.id) {
                      <clr-dg-column [clrDgField]="column.id">
                        <ng-container
                          *clrDgHideableColumn="{
                            hidden:
                              column.id
                              | hideIDColumns
                                : [
                                    'kprolid',
                                    'userimagebase64',
                                    'eisenbahnbetriebsleiter (ebl)',
                                    'anlagenverantwortlicher (alv)',
                                    'user_alv',
                                    'status',
                                    'pwhash',
                                  ],
                          }">
                          {{ column.id | titlecase | mrTranslate }}
                        </ng-container>
                      </clr-dg-column>
                    }
                    <ng-template
                      clrVirtualScroll
                      let-row
                      [clrVirtualRowsOf]="users.rows"
                      [clrVirtualRowsTrackBy]="(_, row) => row?.id">
                      <clr-dg-row [clrDgItem]="row">
                        <clr-dg-action-overflow>
                          <button class="action-item" (click)="editUser(row)">{{ 'Bearbeiten' | mrTranslate }}</button>
                          <button class="action-item" (click)="deleteUser(row.id)">
                            {{ 'Löschen' | mrTranslate }}
                          </button>
                          @if (useMFA) {
                            <button class="action-item" (click)="resteMFA(row)">
                              {{ 'MFA zurücksetzen' | mrTranslate }}
                            </button>
                          }
                        </clr-dg-action-overflow>
                        @for (cell of users.columns; track cell.id) {
                          <clr-dg-cell>{{ row[cell.id] }}</clr-dg-cell>
                        }
                      </clr-dg-row>
                    </ng-template>
                    <clr-dg-footer>{{ users.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                  </clr-datagrid>
                }
                <div class="clr-row" style="padding-top: 0px; margin-top: 0px">
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      align-items: center;
                      width: 100%;
                    ">
                    <h3 style="margin-left: 15px">{{ 'Gruppen' | mrTranslate }}</h3>
                    <button
                      class="btn btn-outline btn-sm"
                      style="min-width: 42px; margin-top: 18px"
                      (click)="showAddGruppe()"
                      [disabled]="!curSelectedRole">
                      <clr-tooltip>
                        <cds-icon clrTooltipTrigger shape="plus" size="20" class="cursor-pointer" />
                        <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                          {{ 'Neue Gruppe anlegen' | mrTranslate }}
                        </clr-tooltip-content>
                      </clr-tooltip>
                    </button>
                  </div>
                </div>
                @if (groups) {
                  <clr-datagrid
                    style="padding-top: 0px; margin-top: -5px"
                    class="datagrid-compact margin--12-t"
                    [clrDgSelectionType]="'multi'"
                    [(clrDgSelected)]="selectedUserGroups">
                    <clr-dg-column clrDgField="Bezeichnung">{{ 'Bezeichnung' | mrTranslate }}</clr-dg-column>
                    <clr-dg-column clrDgField="Rechte">{{ 'Rechte' | mrTranslate }}</clr-dg-column>
                    <clr-dg-row [clrDgSelectable]="selectedRole" *clrDgItems="let grp of groups" [clrDgItem]="grp.id">
                      <clr-dg-action-overflow>
                        <button class="action-item" (click)="editShowGruppe(grp.id)">
                          {{ 'Bearbeiten' | mrTranslate }}
                        </button>
                        @if (grp.id != 1) {
                          <button class="action-item" [disabled]="grp.id == 1" (click)="deleteGruppe(grp.id)">
                            {{ 'Löschen' | mrTranslate }}
                          </button>
                        }
                      </clr-dg-action-overflow>
                      <clr-dg-cell>{{ grp.Bezeichnung }}</clr-dg-cell>
                      <clr-dg-cell>{{ groupRights[grp.Rechte] }}</clr-dg-cell>
                    </clr-dg-row>
                    <clr-dg-footer>{{ groups.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                  </clr-datagrid>
                }
                <div class="clr-row" style="padding-top: 0px; margin-top: 0px">
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      align-items: center;
                      width: 100%;
                    ">
                    <h3 style="margin-left: 15px">{{ 'Auftragsgruppen' | mrTranslate }}</h3>
                    <button
                      class="btn btn-outline btn-sm"
                      style="min-width: 42px; margin-top: 18px"
                      (click)="showAddAuftragGruppe()"
                      [disabled]="!curSelectedRole">
                      <clr-tooltip>
                        <cds-icon clrTooltipTrigger shape="plus" size="20" class="cursor-pointer" />
                        <clr-tooltip-content [clrPosition]="'bottom-left'" [clrSize]="'md'">
                          {{ 'Neue Auftragsgruppen anlegen' | mrTranslate }}
                        </clr-tooltip-content>
                      </clr-tooltip>
                    </button>
                  </div>
                </div>
                @if (auftragsGroups) {
                  <clr-datagrid
                    style="padding-top: 0px; margin-top: -5px"
                    class="datagrid-compact margin--12-t"
                    [clrDgSelectionType]="'multi'"
                    [(clrDgSelected)]="selectedUserAuftragGroups">
                    <clr-dg-column clrDgField="Bezeichnung">{{ 'Bezeichnung' | mrTranslate }}</clr-dg-column>
                    <clr-dg-row
                      [clrDgSelectable]="selectedUser"
                      *clrDgItems="let grp of auftragsGroups"
                      [clrDgItem]="grp.id">
                      <clr-dg-action-overflow>
                        <button class="action-item" (click)="showEditAufGruppe(grp.id)">
                          {{ 'Bearbeiten' | mrTranslate }}
                        </button>
                        @if (grp.id != 1) {
                          <button class="action-item" [disabled]="grp.id == 1" (click)="deleteAuftragGroup(grp.id)">
                            {{ 'Löschen' | mrTranslate }}
                          </button>
                        }
                      </clr-dg-action-overflow>
                      <clr-dg-cell>{{ grp.Bezeichnung }}</clr-dg-cell>
                    </clr-dg-row>
                    <clr-dg-footer>{{ auftragsGroups.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                  </clr-datagrid>
                }
              </div>
            </div>
          </clr-tab-content>
        }
      </clr-tab>

      <!-- Passwortsicherheit -->
      <clr-tab>
        <button clrTabLink (click)="tabChange('security')">
          {{ 'Passwort & Sicherheit' | mrTranslate }}
        </button>

        @if (activeTabs.security) {
          <clr-tab-content>
            <button class="btn btn-sm" style="margin-left: 15px" (click)="setPWSecurity()">
              {{ 'Speichern' | mrTranslate }}
            </button>
            <br />
            <div class="clr-row nxm">
              <div class="clr-col-2">
                <strong>{{ 'Passwortoptionen' | mrTranslate }}:</strong>
              </div>
            </div>
            <div class="clr-row nxm" Style="margin-top: 10px;">
              <div class="clr-col-3">
                <span>{{ 'Mindestlänge an Zeichen' | mrTranslate }}:</span>
              </div>
              <div class="clr-col-3">
                <clr-number-input-container>
                  <!-- <label for="minLengthInput">{{ 'Mindestlänge' | mrTranslate }}</label> -->
                  <input
                    clrNumberInput
                    id="minLengthInput"
                    type="number"
                    min="6"
                    max="30"
                    step="1"
                    name="name"
                    required
                    style="width: 70px"
                    [(ngModel)]="optPWMinL" />
                  <clr-control-error>{{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}</clr-control-error>
                </clr-number-input-container>
              </div>
            </div>
            <div class="clr-row nxm" Style="margin-top: 10px;">
              <div class="clr-col-3">
                <clr-checkbox-container class="margin-0-t">
                  <clr-checkbox-wrapper>
                    <label>{{ 'Kleinbuchstaben erforderlich' | mrTranslate }} {{ '[a-z]' }}</label>
                    <input clrCheckbox type="checkbox" [(ngModel)]="optPWkBuch" />
                  </clr-checkbox-wrapper>
                </clr-checkbox-container>
              </div>
              @if (optPWkBuch) {
                <div class="clr-col-3">
                  <clr-number-input-container>
                    <input
                      type="number"
                      min="1"
                      max="30"
                      step="1"
                      clrNumberInput
                      name="name"
                      required
                      style="width: 70px"
                      [(ngModel)]="optAzkBuch" />
                    <clr-control-error>{{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}</clr-control-error>
                  </clr-number-input-container>
                </div>
              }
            </div>
            <div class="clr-row nxm" Style="margin-top: 10px;">
              <div class="clr-col-3">
                <clr-checkbox-container class="margin-0-t">
                  <clr-checkbox-wrapper>
                    <label>{{ 'Grossbuchstaben erforderlich' | mrTranslate }} {{ '[A-Z]' }}</label>
                    <input clrCheckbox type="checkbox" [(ngModel)]="optPWgBuch" />
                  </clr-checkbox-wrapper>
                </clr-checkbox-container>
              </div>
              @if (optPWgBuch) {
                <div class="clr-col-3">
                  <clr-number-input-container>
                    <input
                      type="number"
                      min="1"
                      max="30"
                      step="1"
                      clrNumberInput
                      name="name"
                      required
                      style="width: 70px"
                      [(ngModel)]="optAzgBuch" />
                    <clr-control-error>{{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}</clr-control-error>
                  </clr-number-input-container>
                </div>
              }
            </div>
            <div class="clr-row nxm" Style="margin-top: 10px;">
              <div class="clr-col-3">
                <clr-checkbox-container class="margin-0-t">
                  <clr-checkbox-wrapper>
                    <label>{{ 'Zahlen erforderlich' | mrTranslate }} {{ '[0-9]' }}</label>
                    <input clrCheckbox type="checkbox" [(ngModel)]="optPWZahl" />
                  </clr-checkbox-wrapper>
                </clr-checkbox-container>
              </div>
              @if (optPWZahl) {
                <div class="clr-col-3">
                  <clr-number-input-container>
                    <input
                      type="number"
                      min="1"
                      max="30"
                      step="1"
                      clrNumberInput
                      name="name"
                      required
                      style="width: 70px"
                      [(ngModel)]="optAzZahl" />
                    <clr-control-error>{{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}</clr-control-error>
                  </clr-number-input-container>
                </div>
              }
            </div>
            <div class="clr-row nxm" Style="margin-top: 10px;">
              <div class="clr-col-3">
                <clr-checkbox-container class="margin-0-t">
                  <clr-checkbox-wrapper>
                    <label>{{ 'Sonderzeichen erforderlich' | mrTranslate }} {{ '[!°@-#$%^?*_+=<>]' }}</label>
                    <input clrCheckbox type="checkbox" [(ngModel)]="optPWSonder" />
                  </clr-checkbox-wrapper>
                </clr-checkbox-container>
              </div>
              @if (optPWSonder) {
                <div class="clr-col-3">
                  <clr-number-input-container>
                    <input
                      type="number"
                      min="1"
                      max="30"
                      step="1"
                      clrNumberInput
                      name="name"
                      required
                      style="width: 70px"
                      [(ngModel)]="optAzSonder" />
                    <clr-control-error>{{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}</clr-control-error>
                  </clr-number-input-container>
                </div>
              }
            </div>
            <div class="clr-row nxm" Style="margin-top: 10px;">
              <clr-radio-container clrInline style="margin-left: 12px">
                <clr-radio-wrapper>
                  <input
                    type="radio"
                    clrRadio
                    [(ngModel)]="optPWExpire"
                    value="0"
                    (change)="handleExpireChange($event)" />
                  <label>{{ 'Passwort läuft nie ab' | mrTranslate }}</label>
                </clr-radio-wrapper>
                <clr-radio-wrapper>
                  <input
                    type="radio"
                    clrRadio
                    [(ngModel)]="optPWExpire"
                    value="1"
                    (change)="handleExpireChange($event)" />
                  <label>{{ 'Passwort läuft ab' | mrTranslate }}</label>
                </clr-radio-wrapper>
              </clr-radio-container>
            </div>
            @if (optShowExpireDate) {
              <div class="clr-row nxm" Style="margin-top: 10px;">
                <div class="clr-col-3">
                  <span>{{ 'Gültigkeit in Tagen' | mrTranslate }}:</span>
                </div>
                <div class="clr-col-3">
                  <clr-number-input-container>
                    <input
                      clrNumberInput
                      id="minLengthInput"
                      type="number"
                      min="30"
                      max="120"
                      step="1"
                      name="name"
                      required
                      style="width: 70px"
                      [(ngModel)]="optPWExpireDays" />
                    <clr-control-error>{{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}</clr-control-error>
                  </clr-number-input-container>
                </div>
              </div>
            }
            @if (optShowExpireDate) {
              <div class="clr-row nxm" Style="margin-top: 10px;">
                <div class="clr-col-3">
                  <span>{{ 'Länge des Kennwortverlaufs' | mrTranslate }}:</span>
                </div>
                <div class="clr-col-3">
                  <clr-number-input-container>
                    <input
                      clrNumberInput
                      id="minLengthInput"
                      type="number"
                      min="0"
                      max="5"
                      step="1"
                      name="name"
                      required
                      style="width: 70px"
                      [(ngModel)]="optPWHistoryCount" />
                    <clr-control-error>{{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}</clr-control-error>
                  </clr-number-input-container>
                </div>
              </div>
            }
            <div class="clr-row nxm" Style="margin-top: 30px;">
              <div class="clr-col-6">
                <strong>
                  {{ 'Einstellungen für Administrator mit Zugriff auf die Benutzerverwaltung' | mrTranslate }}
                </strong>
              </div>
            </div>
            <div class="clr-row nxm" Style="margin-top: 10px;">
              <div class="clr-col-3">
                <span>{{ 'Mindestlänge an Zeichen' | mrTranslate }}:</span>
              </div>
              <div class="clr-col-3">
                <clr-number-input-container>
                  <!-- <label for="minLengthInput">{{ 'Mindestlänge' | mrTranslate }}</label> -->
                  <input
                    clrNumberInput
                    id="minLengthInput"
                    type="number"
                    min="6"
                    max="30"
                    step="1"
                    name="name"
                    required
                    style="width: 70px"
                    [(ngModel)]="optPWAdminMinL" />
                  <clr-control-error>{{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}</clr-control-error>
                </clr-number-input-container>
              </div>
            </div>
            <div class="clr-row nxm" Style="margin-top: 10px;">
              <div class="clr-col-3">
                <clr-checkbox-container class="margin-0-t">
                  <clr-checkbox-wrapper>
                    <label>{{ 'Passwortabfrage für Benutzerverwaltung' | mrTranslate }}</label>
                    <input clrCheckbox type="checkbox" [(ngModel)]="optAdminUsePW" />
                  </clr-checkbox-wrapper>
                </clr-checkbox-container>
              </div>
            </div>
            <div class="clr-row nxm" Style="margin-top: 10px;">
              <div class="clr-col-3">
                <clr-checkbox-container class="margin-0-t">
                  <clr-checkbox-wrapper>
                    <label>{{ '2‑Faktor-Authentifizierung mit Google Authenticator' | mrTranslate }}</label>
                    <input clrCheckbox type="checkbox" [(ngModel)]="optAdminMFA" />
                  </clr-checkbox-wrapper>
                </clr-checkbox-container>
              </div>
            </div>
          </clr-tab-content>
        }
      </clr-tab>
    </clr-tabs>
  </div>
</div>

<!-- Benutzer neu oder ändern -->
<clr-modal [(clrModalOpen)]="isUserEditVisible" [clrModalClosable]="true">
  <h3 class="modal-title" id="modaltitle">{{ showUserGroupTitle | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm clrLayout="vertical" [formGroup]="formUser">
      <div class="clr-row nxm">
        <div class="clr-col-5">
          <div class="avatar-container">
            <img src="{{ _file }}" id="_image" alt="”avatar”" />
            @if (file) {
              <div>
                <button type="button" class="floatAvatarBtn btn btn-link btn-icon" (click)="onFileClear('edit')">
                  <cds-icon shape="times" />
                </button>
              </div>
            } @else {
              <button type="button" class="floatAvatarBtn btn btn-link btn-icon" (click)="onFileOpen('edit')">
                <cds-icon shape="pencil" />
              </button>
            }
          </div>
        </div>
        <div class="clr-col-7">
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 270px">
              <input
                id="_username"
                class="clr-input combobox"
                placeholder="{{ 'Benutzername' | mrTranslate }}"
                name="_username"
                formControlName="username" />
            </div>
          </div>
          <br />
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 270px">
              <input
                id="_pw"
                type="password"
                class="clr-input combobox"
                placeholder="{{ 'Passwort' | mrTranslate }}"
                name="_pw"
                formControlName="pw" />
            </div>
          </div>
          <br />
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 270px">
              <input
                id="_alias"
                class="clr-input combobox"
                placeholder="{{ 'Alias' | mrTranslate }}"
                name="_alias"
                formControlName="alias" />
            </div>
          </div>
          <br />
          <div class="comboboxcontainer">
            <div class="clr-control-container">
              <div class="clr-select-wrapper">
                <select id="_rechte" class="clr-select" style="width: 270px" formControlName="role">
                  @for (role of roles.rows; track role) {
                    <option [ngValue]="+role.ID">
                      {{ role.Rolle }}
                    </option>
                  }
                </select>
              </div>
            </div>
          </div>
          <br />
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 270px">
              <input
                id="_vname"
                class="clr-input combobox"
                placeholder="{{ 'Vorname' | mrTranslate }}"
                name="_vname"
                formControlName="vname" />
            </div>
          </div>
          <br />
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 270px">
              <input
                id="_name"
                class="clr-input combobox"
                placeholder="{{ 'Nachname' | mrTranslate }}"
                name="_name"
                formControlName="nname" />
            </div>
          </div>
          <br />
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 270px">
              <input
                id="_email"
                class="clr-input combobox"
                placeholder="{{ 'EMail' | mrTranslate }}"
                name="_email"
                formControlName="email" />
            </div>
          </div>
          <br />
          <div class="comboboxcontainer">
            <div class="clr-control-container" style="width: 270px">
              <input
                id="_mobil"
                class="clr-input combobox"
                placeholder="{{ 'Mobilnummer' | mrTranslate }}"
                name="_mobil"
                formControlName="mobil" />
            </div>
          </div>
        </div>
      </div>
      <div class="clr-row nxm">
        <div class="clr-col-12 nxp">
          <div class="card">
            <h5 class="card-header">{{ 'Anlagenverantwortung' | mrTranslate }}</h5>
            <div class="card-block">
              <div class="clr-control-container">
                <div class="clr-radio-wrapper">
                  <input
                    type="radio"
                    id="vertical-radio1"
                    value="optkein"
                    (click)="setVerantwortung('optkein')"
                    checked="true"
                    class="clr-radio" />
                  <label for="vertical-radio1" class="clr-control-label">{{ 'kein' | mrTranslate }}</label>
                </div>
                <div class="clr-radio-wrapper">
                  <input
                    type="radio"
                    id="vertical-radio2"
                    value="optalv"
                    (click)="setVerantwortung('optalv')"
                    class="clr-radio" />
                  <label for="vertical-radio2" class="clr-control-label">
                    {{ 'Anlagenverantwortlicher (ALV)' | mrTranslate }}
                  </label>
                </div>
                <div class="clr-radio-wrapper">
                  <input
                    type="radio"
                    id="vertical-radio3"
                    value="optebl"
                    (click)="setVerantwortung('optebl')"
                    class="clr-radio" />
                  <label for="vertical-radio3" class="clr-control-label">
                    {{ 'Eisenbahnbetriebsleiter (EBL)' | mrTranslate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="updateUser($event)">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="isUserEditVisible = false">{{ 'Beenden' | mrTranslate }}</button>
  </div>
</clr-modal>

<!-- Gruppe neu oder ändern -->
<clr-modal [(clrModalOpen)]="isGroupEditVisible" [clrModalClosable]="true">
  <h3 class="modal-title">{{ showEditGroupTitle | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm [formGroup]="formUserGroup">
      <div class="clr-row nxm" style="margin-top: -15px">
        <div class="clr-col-12 nxp">
          <clr-input-container>
            <label class="clr-required-mark">{{ 'Gruppe' | mrTranslate }}</label>
            <input
              clrInput
              formControlName="name"
              placeholder="{{ 'Bezeichnung' | mrTranslate }}"
              style="min-width: 350px; width: 350px"
              required />
          </clr-input-container>
          <clr-select-container>
            <label class="clr-required-mark">{{ 'Rechte' | mrTranslate }}</label>
            <select
              clrSelect
              id="auftragsgruppe"
              formControlName="rechte"
              style="min-width: 350px; width: 350px"
              required>
              <option value="1">{{ 'lesen' | mrTranslate }}</option>
              <option value="2">{{ 'lesen und schreiben' | mrTranslate }}</option>
            </select>
          </clr-select-container>
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="editGruppe()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="isGroupEditVisible = false">{{ 'Beenden' | mrTranslate }}</button>
  </div>
</clr-modal>

<!-- Auftragsgruppe neu oder ändern -->
<clr-modal [(clrModalOpen)]="showAufGroupEdit" [clrModalClosable]="true">
  <h3 class="modal-title">{{ showEditAuftragsGroupTitle | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm [formGroup]="formUserAuftragGroup">
      <div class="clr-row nxm" style="margin-top: -15px">
        <div class="clr-col-12 nxp">
          <clr-input-container>
            <label class="clr-required-mark">{{ 'Gruppe' | mrTranslate }}</label>
            <input
              clrInput
              formControlName="name"
              placeholder="{{ 'Auftragsgruppe' | mrTranslate }}"
              style="min-width: 350px; width: 350px"
              required />
          </clr-input-container>
          <clr-input-container>
            <label>{{ 'Kostenstelle' | mrTranslate }}</label>
            <input
              clrInput
              formControlName="kost"
              placeholder="{{ 'Kostenstelle' | mrTranslate }}"
              style="min-width: 350px; width: 350px" />
          </clr-input-container>
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="editAufGruppe()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="showAufGroupEdit = false">{{ 'Beenden' | mrTranslate }}</button>
  </div>
</clr-modal>

<!-- Rolle neu oder ändern -->
<clr-modal [(clrModalOpen)]="showEditRole" [clrModalClosable]="true">
  <h3 class="modal-title">{{ showEditRoleTitle | mrTranslate }}</h3>
  <div class="modal-body">
    <form clrForm [formGroup]="formRole">
      <div class="clr-row nxm" style="margin-top: -15px">
        <div class="clr-col-12 nxp">
          <clr-input-container>
            <label class="clr-required-mark">{{ 'Rolle' | mrTranslate }}</label>
            <input
              clrInput
              formControlName="rolle"
              placeholder="{{ 'Bezeichnung' | mrTranslate }}"
              style="min-width: 350px; width: 350px"
              required />
          </clr-input-container>
          <clr-select-container>
            <label class="clr-required-mark">{{ 'Rechte' | mrTranslate }}</label>
            <select
              clrSelect
              id="auftragsgruppe"
              formControlName="rechte"
              style="min-width: 350px; width: 350px"
              required>
              <option value="1">{{ 'lesen' | mrTranslate }}</option>
              <option value="2">{{ 'bearbeiten' | mrTranslate }}</option>
              <option value="3">{{ 'ändern' | mrTranslate }}</option>
              <option value="4">{{ 'Störungsbearbeiter' | mrTranslate }}</option>
              <option value="5">{{ 'Inspekteur' | mrTranslate }}</option>
              <option value="6">{{ 'Administrator' | mrTranslate }}</option>
            </select>
          </clr-select-container>
        </div>
      </div>
    </form>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" type="submit" (click)="sendEditRolle()">
      {{ 'OK' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="showEditRole = false">{{ 'Beenden' | mrTranslate }}</button>
  </div>
</clr-modal>
